<div class="container container-e-service-request">
  <form [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
    <app-request-title></app-request-title>

    <section class="card border-dark mb-4">
      <div class="card-header text-white bg-dark">
        {{
          'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.NOTIFICATION_TYPE'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="form-check form-check-inline">
          <input
            type="radio"
            [id]="constructionNotificationType.ConstructionIntention"
            [attr.name]="controlName.ConstructionIntention"
            [formControlName]="controlName.ConstructionIntention"
            [value]="constructionNotificationType.ConstructionIntention"
            class="form-check-input"
          />

          <label
            class="form-check-label"
            [attr.for]="constructionNotificationType.ConstructionIntention"
          >
            {{
              'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.CONSTRUCTION_INTENTION'
                | translate
            }}
          </label>
        </div>

        <div class="form-check form-check-inline">
          <input
            type="radio"
            [id]="constructionNotificationType.ConstructionWorksExecution"
            [attr.name]="controlName.ConstructionIntention"
            [formControlName]="controlName.ConstructionIntention"
            [value]="constructionNotificationType.ConstructionWorksExecution"
            class="form-check-input"
          />

          <label
            class="form-check-label"
            [attr.for]="constructionNotificationType.ConstructionWorksExecution"
          >
            {{
              'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.CONSTRUCTION_WORKS_EXECUTION'
                | translate
            }}
          </label>
        </div>
      </div>
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        !isInvestorDetailsFormGroupValid() && submitted
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'EXCLUDING_LAND_FROM_AGRICULTURAL_PRODUCTION.INVESTOR_DETAILS.TITLE'
            | translate
        }}
      </div>

      <div class="card-body">
        <app-investor-details
          [investorDetailsFromGroup]="getInvestorDetailsFormGroup()"
        ></app-investor-details>
      </div>
    </section>

    <app-proxy-details
      #proxyDetails
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-proxy-details>

    <section
      class="card mb-4"
      [ngClass]="
        checkIdentificationConstructionIntentValidAndFormValidated()
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.PROPERTY_DATA'
            | translate
        }}
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-4 col-sm-6 col-xs-12 my-1">
            <label
              class="text-nowrap"
              [attr.for]="controlName.BuildingNameAndType"
            >
              {{
                'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.BUILDING_NAME_AND_TYPE'
                  | translate
              }}
            </label>

            <input
              type="text"
              [name]="controlName.BuildingNameAndType"
              [id]="controlName.BuildingNameAndType"
              class="form-control form-control-sm required"
              aria-required="true"
              [formControlName]="controlName.BuildingNameAndType"
            />

            @if (
              shouldShowErrorAlert(
                getBuildingNameAndTypeFormControl(),
                'required'
              )
            ) {
              <div class="alert alert-danger">
                {{ 'FIELD_REQUIRED' | translate }}
              </div>
            }
          </div>
        </div>

        <div class="mb-4">
          <gk-address-form
            [isRequired]="true"
            [isBuildingNumberRequired]="false"
            [form]="formGroup"
            [idPrefix]="'constructionNotification'"
          ></gk-address-form>
        </div>

        <gk-map
          [mapState]="mapState"
          (dispatch)="handleMapAction($event)"
        ></gk-map>

        <div class="mt-2">
          @if (mapState.mapObjectTablesState[0].mapObjects.length) {
            <gk-map-object-table
              [mapState]="mapState"
              [mapObjectTableStateIndex]="0"
              (dispatch)="handleMapAction($event)"
            ></gk-map-object-table>
          }
        </div>
      </div>

      @if (submitted && !areParcelsChosen()) {
        <div class="card-footer">
          <div class="alert alert-danger mt-2">
            {{
              'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.PARCELS_REQUIRED'
                | translate
            }}
          </div>
        </div>
      }
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkDescriptionValidAndFormValidated()
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <div class="card-header text-white bg-dark">
        {{
          'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.DESCRIPTION'
            | translate
        }}
      </div>

      <div class="card-body">
        <textarea
          [name]="controlName.Description"
          [id]="controlName.Description"
          class="form-control required"
          aria-required="true"
          [formControlName]="controlName.Description"
        ></textarea>

        @if (shouldShowErrorAlert(getDescriptionFormControl(), 'required')) {
          <div class="alert alert-danger">
            {{ 'FIELD_REQUIRED' | translate }}
          </div>
        }
      </div>
    </section>

    <section
      class="card mb-4"
      [ngClass]="
        checkConstructionWorksCommencementDateFormControlValidAndFormValidated()
          ? 'border-danger border-2'
          : 'border-dark'
      "
    >
      <label
        class="card-header text-white bg-dark"
        [attr.for]="controlName.ConstructionWorksCommencementDate"
      >
        {{
          'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.CONSTRUCTION_WORKS_COMMENCEMENT_DATE'
            | translate
        }}
      </label>

      <div class="card-body">
        <div class="input-group">
          <input
            class="form-control form-control-sm required"
            aria-required="true"
            [attr.placeholder]="'GK.DYNAMIC_LIST.DATE_PLACEHOLDER' | translate"
            [id]="controlName.ConstructionWorksCommencementDate"
            [name]="controlName.ConstructionWorksCommencementDate"
            [formControlName]="controlName.ConstructionWorksCommencementDate"
            ngbDatepicker
            #d="ngbDatepicker"
          />

          <button
            class="btn btn-outline-secondary fa fa-calendar"
            (click)="d.toggle()"
            type="button"
          ></button>
        </div>

        <div class="alert alert-info mt-2" role="alert">
          {{
            'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.CONSTRUCTION_WORKS_COMMENCEMENT_DATE_INFO'
              | translate
          }}
        </div>
      </div>
    </section>

    <gk-attachments
      [portalId]="portalId"
      [submitted]="submitted"
      [requiredPowerOfAttorney]="proxyDetails.detailsVisible"
    >
    </gk-attachments>

    <app-request-reply-form
      [portalId]="portalId"
      [formGroup]="formGroup"
      [submitted]="submitted"
    ></app-request-reply-form>

    <section>
      <div class="card border-dark mb-4">
        <div class="card-header text-white bg-dark">
          {{
            'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.INSTRUCTION'
              | translate
          }}
        </div>

        <div class="card-body">
          <P
            [innerHTML]="
              'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.INSTRUCTION_INFO'
                | translate
            "
          >
          </P>
        </div>
      </div>
    </section>

    <button type="submit" class="btn btn-primary">
      {{
        'CONSTRUCTION_PORTAL.CONSTRUCTION_NOTIFICATION.FIELDS.SUBMIT_REQUEST'
          | translate
      }}
    </button>

    <app-doc-sign-info
      [messageText]="docSignMsgTxt"
      [messageType]="docSignMsgType"
      [docSignUrl]="docSignUrl"
      [docSignPending]="docSignPending"
    ></app-doc-sign-info>

    <div class="mt-2"><app-form-legend></app-form-legend></div>
  </form>
</div>

<ng-template #canDeactivateModal let-close="close">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'MODAL_CAN_DEACTIVATE.ALERT_TITLE' | translate }}
    </h4>
  </div>

  <div class="modal-body">
    {{ 'MODAL_CAN_DEACTIVATE.DESCRIPTION' | translate }}
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close(false)">
      {{ 'MODAL_CAN_DEACTIVATE.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="close(true)">
      {{ 'MODAL_CAN_DEACTIVATE.CONFIRM' | translate }}
    </button>
  </div>
</ng-template>
